module.exports = __webpack_public_path__ + "web/img/sign-30.baa2bbb7.png";